import { Phone } from "./phone.model";

export class Brand {
    //public id:number;

    public name:string;
    public phones:Phone[];

    

    constructor(name:string,phones:Phone[]){
    
    
        this.name=name;
        this.phones=phones;
    

    }
}


// WEBPACK FOOTER //
// G:/phoneinfo2/phoneinfo/src/app/models/brand.model.ts